import { Slice } from '@reduxjs/toolkit';
import { ModelContext, ModelMap } from '../common/types/models';
import { GenericCRUDActions, CrudActionEssential } from './crud.actions';
import { createCollectionSlice } from './generic.slice';
import { ReduxState, ReduxStateKeys } from './store.interface';

const sliceName: ReduxStateKeys = 'rfps';
type SliceType = ReduxState[typeof sliceName];
type ModelType = ModelMap[ModelContext.RFP];

const initialState: SliceType = [];

export const {
  readById,
  readAll,
  createRecord,
  updateRecord,
  deleteRecord,
}: CrudActionEssential<ModelType> = new GenericCRUDActions<ModelType>(
  sliceName,
);
const crudActions: CrudActionEssential<ModelType> = {
  readById,
  readAll,
  createRecord,
  updateRecord,
  deleteRecord,
};
const rfps: Slice<ModelType[]> = createCollectionSlice<ModelType>({
  name: sliceName,
  initialState,
  crudActions,
});

export const { add, replaceAll, update, remove } = rfps.actions;
export default rfps.reducer;
